import React from 'react'
import BannerContent from './BannerContent'
import { FlexRow, Box, Icon, SuspenseBoundary } from 'elements'
// import DropdownOptions from './DropdownOptions'

export const BANNER_HEIGHT = 140

export default function BannerContainer() {
  return (
    <FlexRow
      alignItems="center"
      justifyContent="space-between"
      bg="secondary.2"
      height={`${BANNER_HEIGHT}px`}
      px="large"
    >
      <FlexRow alignItems="center">
        <Box borderRadius="full" bg="background.0" mr="large" p="xlarge">
          <Icon name="globe-alt" color="secondary.0" size="xxlarge" />
        </Box>
        <SuspenseBoundary>
          <BannerContent />
        </SuspenseBoundary>
      </FlexRow>
      {/* <DropdownOptions /> */}
    </FlexRow>
  )
}
